<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Azienda </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_nuovo = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Calendario</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-text-field label="Azienda" v-model="azienda_cod" />
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-text-field label="Id azienda" v-model="azienda_id" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <CalendarioGenerico
            @click_chiudi="dialog_calendario_generico = false" ref="ref_generico"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="dialog_calendario_specifico = false" :tipo = 0 :id_riferimento= 1
      />
    </v-dialog>
    <!-- DIALOG NUOVO CALENDARIO -->
    <v-dialog v-model="dialog_calendario_nuovo" width="700px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Nuovo calendario</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiCalendario" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <!-- Bottone calendario specifico --> 
          <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_specifico = true"
            small
            v-bind="attrs"
            v-on="on"
            class="ml-5"
          >
            <v-icon color="primary"> mdi-calendar-star </v-icon>
          </v-btn>
        </template>
        <span>Giorni specifici</span>
      </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_calendario_nuovo = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Lunedì: </h3></v-col>
            <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lunedi.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lunedi.ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Martedì:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="martedi.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="martedi.ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Mercoledì:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="mercoledi.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="mercoledi.ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Giovedì:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="giovedi.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="giovedi.ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Venerdì:</h3></v-col>
            <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="venerdi.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="venerdi.ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Sabato:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="sabato.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="sabato.ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Domenica:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="domenica.ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="domenica.ora_a"></v-text-field></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: { SnackbarQV, CalendarioGenerico, CalendarioSpecifico },

  props: [],

  data() {
    return {
      // Variabili d'appoggio
      azienda_id: localStorage.getItem("id_azienda"),
      azienda_cod: localStorage.getItem("cod_azienda"),
      lunedi: {},
      martedi: {},
      mercoledi: {},
      giovedi: {},
      venerdi: {},
      sabato: {},
      domenica: {},

      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,
      dialog_calendario_nuovo: false,

      // Array
      lista_ore: [0,
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24,
      ],
    };
  },

  computed: {},

  watch: {},

  methods: {
    aggiungiCalendario() {

      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "setcalendario",
          token: localStorage.getItem("user_token"),
          calendario: {
            id_calendario: -1,
            priorita: 1,
            validita: 1,
          },
          fasce: [
            {
              id_calendario_orario: -1,
              num_giorno: 1,
              ora_da: this.lunedi.ora_da==undefined? null: this.lunedi.ora_da + ":00",
              ora_a: this.lunedi.ora_a == undefined? null: this.lunedi.ora_a + ":00",
              validita: 1,
              
            },
            {
              id_calendario_orario: -1,
              num_giorno: 2,
              ora_da: this.martedi.ora_da==undefined? null: this.martedi.ora_da + ":00",
              ora_a: this.martedi.ora_a == undefined? null: this.martedi.ora_a + ":00",
              validita: 1,
              
            },
            {
              id_calendario_orario: -1,
              num_giorno: 3,
              ora_da: this.mercoledi.ora_da==undefined? null: this.mercoledi.ora_da + ":00",
              ora_a: this.mercoledi.ora_a == undefined? null: this.mercoledi.ora_a + ":00",
              validita: 1,
              
            },
            {
              id_calendario_orario: -1,
              num_giorno: 4,
              ora_da: this.giovedi.ora_da==undefined? null: this.giovedi.ora_da + ":00",
              ora_a: this.giovedi.ora_a == undefined? null: this.giovedi.ora_a + ":00",
              validita: 1,
              
            },
            {
              id_calendario_orario: -1,
              num_giorno: 5,
              ora_da: this.venerdi.ora_da==undefined? null: this.venerdi.ora_da + ":00",
              ora_a: this.venerdi.ora_a == undefined? null: this.venerdi.ora_a + ":00",
              validita: 1,
              
            },
            {
              id_calendario_orario: -1,
              num_giorno: 6,
              ora_da: this.sabato.ora_da==undefined? null: this.sabato.ora_da + ":00",
              ora_a: this.sabato.ora_a == undefined? null: this.sabato.ora_a + ":00",
              validita: 1,
              
            },
            {
              id_calendario_orario: -1,
              num_giorno: 7,
              ora_da: this.domenica.ora_da==undefined? null: this.domenica.ora_da + ":00",
              ora_a: this.domenica.ora_a == undefined? null: this.domenica.ora_a + ":00",
              validita: 1,
              
            },
          ],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print(
            "success",
            `Salvataggio effettuato.`
          );

          this.$refs.ref_generico.getCalendario();

          this.dialog_calendario_nuovo = false;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
  },

  created() {},

  mounted() {},
};
</script>

<style scoped>
</style>